<div class="dashboard-header" @fadeInUp>
    <!-- <h1 class="dashboard-header__title">
        <span class="dashboard-header__subtitle">{{ subtitle }}</span>
    </h1> -->
    <!-- <div class="dashboard-header__actions">
        <button (click)="onAddClient()">
            {{ buttonText }}
        </button>
    </div> -->
</div>
